import React, {useEffect, useState} from 'react';
import {useController, useForm} from "react-hook-form";
import moment from "moment/moment";
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import LoadingButton from "../../base/components/loadingButton";
import FormHookSelect from "../../air/airBooking/components/formHookSelect";
import _ from "lodash";
import SearchSelect from "../../../components/searchSelect";
import axios from "../../../helpers/axios";
import BlockUi from "@availity/block-ui";
import {Col, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import numberFormat from "../../../helpers/numberFormat";

const SupplierCheck = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState()
  const [suppliersList, setSuppliersList] = useState()
  const defaultVal ={
    supplierId: '',
    start: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY')
  }

  const formController = useForm({defaultValues:defaultVal})
  const {setValue,
    handleSubmit,
    formState:{errors},
    control} = formController
  const {
    field: { onChange: supplierOnChange, value: supplierValue }
  } = useController({
    name: `supplierId`,
    control,
    rules: { required: true },
    defaultValue: ''
  });

  useEffect(() => {
    axios.post('/api/counterparty/suppliers/getAll',{type: 'service'})
      .then(({data})=>{
        const europeles = _.find(data.data, v=>v.label.includes('Europeles'))
        supplierOnChange(europeles.value)
        setSuppliersList([europeles])
      })
  }, []);

  const onSubmit = (data) =>{
    setLoading(true)
    axios.post('/api/racoon/pdfParse/checkSupplierCash',data)
      .then(({data})=>{
        data.cash.forEach(row=>{
          const currency = row.eurSumm ? 'EUR' : row.currency
          const summ = row.eurSumm ? row.eurSumm : row.summ
          row.currency = currency
          row.summ = summ
        })
        setData(data)
      })
      .finally(()=>setLoading(false))

  }
  return (
    <>
      <Helmet>
        <title>Сверка по поставщику</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={'Сверка'} toolbar={<PortletHeaderToolbar>
          <BlockUi blocking={!suppliersList}>
            <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2'}>
              <CustomDatePicker formController={formController}
                                label={"Дата c"}
                                value={defaultVal.start}
                                name={`start`}
                                rules={{required: true}}/>
              <CustomDatePicker formController={formController}
                                label={"Дата по"}
                                value={defaultVal.end}
                                name={`end`}
                                rules={{required: true}}/>
              {suppliersList && <SearchSelect label={'Поставщик'}
                                              onChange={(e) => {
                                                supplierOnChange(e)
                                              }}
                                              hasError={_.get(errors, `supplierId`)}
                                              defaultValue={supplierValue}
                                              errors={errors}
                                              array={suppliersList}/>}
              <LoadingButton loading={loading} title={'Получить'}/>
            </form>
          </BlockUi>
        </PortletHeaderToolbar>}/>
        <BlockUi blocking={loading}>
          <PortletBody>
            {data &&
              <Row>
                <Col>
                  <div className={'d-flex justify-content-between gap-2'} style={{fontSize: 17}}>
                    <div>Сальдо на начало:</div>
                    <b className={'d-flex gap-2'}>
                      {data.servicesSaldo.map((curr, index) => {
                        return <div key={index}>
                          {numberFormat(curr.saldo)} {curr.currency}
                        </div>
                      })}
                    </b>
                  </div>
                  <div className={'d-flex justify-content-between gap-2'} style={{fontSize: 17}}>
                    <div>Закуп на сумму:</div>
                    <b className={'d-flex gap-2'}>
                      {Object.keys(_.groupBy(data.services, 'currency')).map((key, index) => {
                        return <div key={index}>
                          {numberFormat(_.sumBy(data.services, (s) => {
                            return s.currency === key && s.summ
                          }))} {key}
                        </div>
                      })}
                    </b>
                  </div>
                  <Table bordered striped>
                    <thead>
                    <tr>
                      <th>Дата</th>
                      <th>Покупатель</th>
                      <th>Сумма</th>
                      <th>Валюта</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.services.map((s, i) => {
                      return <tr key={i}>
                        <td><Link to={s.baseLink + s.id} target={'_blank'}>{s.date}</Link></td>
                        <td>{s.buyer}</td>
                        <td>{numberFormat(s.summ)}</td>
                        <td>{s.currency}</td>
                      </tr>
                    })}
                    </tbody>
                  </Table>
                </Col>
                <Col>
                  <div className={'d-flex justify-content-between gap-2'} style={{fontSize: 17}}>
                    <div>Сальдо на начало:</div>
                    <b className={'d-flex gap-2'}>
                      {data.cashSaldo.map((curr, index) => {
                        return <div key={index}>
                          {numberFormat(curr.saldo)} {curr.currency}
                        </div>
                      })}
                    </b>
                  </div>
                  <div className={'d-flex justify-content-between gap-2'} style={{fontSize: 17}}>
                    <div>Заплатили:</div>
                    <b className={'d-flex gap-2'}>
                      {Object.keys(_.groupBy(data.cash, 'currency')).map((key, index) => {
                        return <div key={index}>
                          {numberFormat(_.sumBy(data.cash, (s) => {
                            return s.currency === key && s.summ
                          }))} {key}
                        </div>
                      })}
                    </b>
                  </div>
                  <Table bordered striped>
                    <thead>
                    <tr>
                      <th>Дата</th>
                      <th>Лист</th>
                      <th>Строка</th>
                      <th>Сумма</th>
                      <th>Валюта</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.cash.map((s, i) => {
                      return <tr key={i}>
                        <td>{s.date}</td>
                        <td>{s.sheet}</td>
                        <td>{s.index}</td>
                        <td>{numberFormat(s.summ)}</td>
                        <td>{s.currency}</td>
                      </tr>
                    })}
                    </tbody>
                  </Table>
                </Col>
              </Row>}
          </PortletBody>
        </BlockUi>
      </Portlet>

    </>
  );
};

export default SupplierCheck;
